/* eslint-disable no-unused-vars */

const DAY_MS = 86400000;

const COLORS = {
	DARKBLUE: "#003170",
	WHITE: "white",
	PURPLE: "#7C549E"
};

function colorValues(color)
{
    if (color === '')
        return;
    if (color.toLowerCase() === 'transparent')
        return [0, 0, 0, 0];
    if (color[0] === '#')
    {
        if (color.length < 7)
        {
            // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
            color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
        }
        return [parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16)/255 : 1];
    }
    if (color.indexOf('rgb') === -1)
    {
        // convert named colors
        var temp_elem = document.body.appendChild(document.createElement('fictum')); // intentionally use unknown tag to lower chances of css rule override with !important
        var flag = 'rgb(1, 2, 3)'; // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
        temp_elem.style.color = flag;
        if (temp_elem.style.color !== flag)
            return; // color set failed - some monstrous css rule is probably taking over the color of our object
        temp_elem.style.color = color;
        if (temp_elem.style.color === flag || temp_elem.style.color === '')
            return; // color parse failed
        color = getComputedStyle(temp_elem).color;
        document.body.removeChild(temp_elem);
    }
    if (color.indexOf('rgb') === 0)
    {
        if (color.indexOf('rgba') === -1)
            color += ',1'; // convert 'rgb(R,G,B)' to 'rgb(R,G,B)A' which looks awful but will pass the regxep below
        // eslint-disable-next-line no-useless-escape
        return color.match(/[\.\d]+/g).map(function (a)
        {
            return +a;
        });
    }
}

function getRGB(str) {
	//var match = colorValues(str);
	var match = colorValues(str);
	return (null === match) ? {} : { red: match[0], green: match[1], blue: match[2], alpha: match[3] };
}

function toDateStr(value) {
	if (typeof value === 'string' || value instanceof String) {

		var timestamp = Date.parse(value);

		if (false === isNaN(timestamp)) {
			value = new Date(timestamp);
		}
	}
	else if (typeof value === 'number' && false === isNaN(value)) {
		value = new Date(value);
	}

	if (value instanceof Date) {
		return value.toLocaleDateString(navigator.language, {day:"2-digit", month:"short", year:"numeric"});
	}
	else {
		return value;
	}

}

function xAxesTickFormatter(value, index, values) {

	var str = toDateStr(value);

	if (index === (values.length-1)) {
		return [str, '(Now)'];
	}
	else {
		return str;
	}

}

function updateDatasetColorGradient(dataset, color, canvas) {
	updateDatasetColorGradientWithHeight(dataset, color, canvas, canvas.clientHeight);
}

function updateDatasetColorGradientWithHeight(dataset, color, canvas, height) {
	const rgb = getRGB(color); //getRGB(COLORS.PURPLE);

	const ctx = canvas.getContext("2d");

	const gradientFill = ctx.createLinearGradient(0, height * 0.7, 0, height * 0.1);
	gradientFill.addColorStop(0, "rgba(" + rgb.red + "," + rgb.green + "," + rgb.blue + ", 0.0)");
	gradientFill.addColorStop(1, "rgba(" + rgb.red + "," + rgb.green + "," + rgb.blue + ", 0.9)");

	dataset.backgroundColor = gradientFill;
}

function initDataset(dataset, color, canvas, useGradient) {

	// console.log('initDataset', dataset, color, canvas);

	if ((undefined === useGradient) || useGradient) {
		updateDatasetColorGradient(dataset, color, canvas);
	}
	else {
		dataset.backgroundColor = 'transparent';
	}

	// console.log('initDataset', dataset, color, canvas);

	dataset.borderColor = color; //COLORS.PURPLE;
	dataset.pointBackgroundColor = color;
	dataset.pointBorderWidth = 2;
	dataset.pointRadius = 8;
	dataset.pointHoverBorderWidth = 2;
	dataset.pointHoverRadius = 8;
	dataset.borderWidth = 2;

	// console.log('initDataset', dataset, color, canvas);

	dataset.data = [];
	dataset.label = '';
	dataset.fill = 'start';
	dataset.showLine = true;

	// console.log('initDataset', dataset, color, canvas);
}

function generateLegendLabels(chart) {
	
	var retVal = [];

	for (var i = 0; i < chart.config.data.datasets.length; i++) {
		retVal[i] = {
			text: chart.config.data.datasets[i].label,
			fillStyle: chart.config.data.datasets[i].color, //COLORS.PURPLE,
			hidden: false,
			lineCap: 'round',
			lineDash: chart.config.data.datasets[i].borderDash,
			lineDashOffset: chart.config.data.datasets[i].borderDashOffset,
			lineJoin: 'round',
			lineWidth: 10,
			strokeStyle: chart.config.data.datasets[i].color, //COLORS.PURPLE,
			pointStyle: null,
	
			padding: 10, // Magstim custom
	
			// Below is extra data used for toggling the datasets
			datasetIndex: i
		};
	}
	
	return retVal;
}

export function getSettings() {

	var data = {
		labels: [],
		datasets: [ ]
	};
		
	var options = {
		responsive: true,
		maintainAspectRatio: false,
		onResize: function(chart, newSize) {
			// eslint-disable-next-line no-console
			console.log('chart.canvas=' + chart.canvas.width + 'x' + chart.canvas.height + ' - newSize=' + newSize.width + 'x' + newSize.height);
		},
		spanGaps: false,
		elements: {
			line: {
				tension: 0.35 //0.000001
			}
		},
		plugins: {
			filler: {
				propagate: false
			}
		},
		legend: {
			display: true,
			labels: {
				fontSize: 18,
				usePointStyle: false,
				padding: 16,
				borderColor: COLORS.PURPLE,
				// eslint-disable-next-line no-unused-vars
				generateLabels: generateLegendLabels,
				boxWidth: 40
			},
			onClick: function(e) {
				e.stopPropagation();
			},
			position: 'bottom'
		},
		animation: {
			animateScale: true,
			animateRotate: true
		},
		tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
					var label = '';
					
					if (data.datasets.length > 1) {
						label += data.datasets[tooltipItem.datasetIndex].label || '';

						if (label) {
							label += ': ';
						}
					}

                    label += toDateStr(tooltipItem.xLabel);
                    label += ', ' + Math.round(tooltipItem.yLabel * 100) / 100;
                    return label;
                }
            }
        },
		scales: {
			xAxes: [{
				ticks: {
					autoSkip: true,
					fontSize: 14,
					padding: 20,
					maxTicksLimit: 8,
					stepSize: DAY_MS,
					callback: xAxesTickFormatter,
					maxRotation: 0
				},
				gridLines: {
					drawBorder: false,
					color: '#EAF0F4',
					tickMarkLength: 0
				}
			}],
			yAxes: [{
				scaleLabel: {
					display: false,
					labelString: '',
					fontSize: 14,
				  },
				ticks: {
					autoSkip: true,
					fontSize: 14,
					padding: 20
				},
				gridLines: {
					drawBorder: false,
					color: '#EAF0F4',
					tickMarkLength: 0
				}
			}]
		}
	};
	
	return {
		type: 'scatter',
		data: data,
		options: options
	};

}

function getCanvas(canvas) {
	
	if (typeof canvas === 'string' || canvas instanceof String) {
		canvas = document.getElementById(canvas);
	}

	if ((undefined === canvas) || (null === canvas)) {
		console.log('LineChart.js : init : canvas NOT INITIALISED', canvas);
	}

	return canvas;
}

export function setSettings(canvas, settings) {
	
	// console.log('setSettings', settings, canvas, canvas.chart);
	
	canvas = getCanvas(canvas);
	
	if ((undefined !== canvas) && (undefined !== canvas.chart)) {
		console.log(`LineChart.js : setSettings : calling chart.update ${canvas.chart.config.options.scales.yAxes[0].ticks.min}..${canvas.chart.config.options.scales.yAxes[0].ticks.stepSize}..${canvas.chart.config.options.scales.yAxes[0].ticks.max}`, canvas.chart);
		canvas.chart.config = settings;
		//canvas.chart.update();
		console.log(`LineChart.js : setSettings : calling chart.update ${canvas.chart.config.options.scales.yAxes[0].ticks.min}..${canvas.chart.config.options.scales.yAxes[0].ticks.stepSize}..${canvas.chart.config.options.scales.yAxes[0].ticks.max}`, canvas.chart);
	}
}

// eslint-disable-next-line no-unused-vars
export function init(canvas, settings) {
	
	if (undefined === settings) {
		settings = getSettings();
	}
	// console.log(`LineChart.init`, canvas);

	// eslint-disable-next-line no-undef
	Chart.defaults.global.defaultFontFamily = 'Montserrat';
	// eslint-disable-next-line no-undef
	Chart.defaults.global.defaultFontColor = COLORS.WHITE;
	
	canvas = getCanvas(canvas);

	if ((undefined === canvas) || (null === canvas)) {
		return;
	}

	// console.log(`LineChart.js : init : canvas=${canvas} `, settings);

	// eslint-disable-next-line no-undef
	canvas.chart = new Chart(canvas, settings);
}

export function setup(canvas, yMin, max, series, yStepSize) {

	//console.log(`LineChart.js : setup : canvas=${canvas} min=${min} max=${max} series=${JSON.stringify(series, null, 4)} `);

	setupMulti(canvas, yMin, max, [series], yStepSize);
}

export function setupMulti(canvas, yMin, yMax, seriesArray, yStepSize) {

	// console.log(`LineChart.js : setupMulti yMin=${yMin} yMax=${yMax}`, canvas, seriesArray);

	canvas = getCanvas(canvas);
	
	if ((undefined === canvas) || (null === canvas)) {
		console.log(`LineChart.js : setupMulti : canvas NOT INITIALISED yMin=${yMin} yMax=${yMax}`, seriesArray);
		return;
	}

	const chart = canvas.chart;

	if ((undefined === chart) || (null === chart)) {
		console.log(`LineChart.js : setupMulti : chart NOT INITIALISED yMin=${yMin} yMax=${yMax}`, seriesArray);
		return;
	}

	if ((undefined !== chart.config.data.datasets) && (chart.config.data.datasets.length > seriesArray.length)) {
		chart.config.data.datasets = chart.config.data.datasets.slice(0, seriesArray.length)
	}

	for (var seriesIndex = 0; seriesIndex < seriesArray.length; seriesIndex++) {
		//if (undefined === chart.config.data.datasets[seriesIndex]) {
			
			chart.config.data.datasets[seriesIndex] = {};

			if (undefined === seriesArray[seriesIndex].color) {
				seriesArray[seriesIndex].color = COLORS.PURPLE;
			}
			else {
				// console.log(`LineChart.js : setupMulti : seriesArray[${seriesIndex}].color=${seriesArray[seriesIndex].color}`);
			}

			initDataset(chart.config.data.datasets[seriesIndex], seriesArray[seriesIndex].color, canvas, seriesArray[seriesIndex].useGradient);
		//}

		chart.config.data.datasets[seriesIndex].label = seriesArray[seriesIndex].title;
		chart.config.data.datasets[seriesIndex].color = seriesArray[seriesIndex].color;
	}

	chart.config.data.datasets[0].data = [];
	for (seriesIndex = 0; seriesIndex < seriesArray.length; seriesIndex++) {
		for (var xIndex = 0; xIndex < seriesArray[seriesIndex].xValues.length; xIndex++) {
			if (typeof seriesArray[seriesIndex].xValues[xIndex] === 'string' || seriesArray[seriesIndex].xValues[xIndex] instanceof String) {
				var timestamp = Date.parse(seriesArray[seriesIndex].xValues[xIndex]);
				if (isNaN(timestamp) === false) {
					seriesArray[seriesIndex].xValues[xIndex] = timestamp;
				}
			}
		}
	}

	chart.config.options.scales.xAxes[0].ticks.min = Number.MAX_SAFE_INTEGER;
	chart.config.options.scales.xAxes[0].ticks.max = Number.MIN_SAFE_INTEGER;
	
	for (seriesIndex = 0; seriesIndex < seriesArray.length; seriesIndex++) {
		for (xIndex = 0; xIndex < seriesArray[seriesIndex].xValues.length; xIndex++) {
			chart.config.data.datasets[seriesIndex].data[xIndex] = { x: seriesArray[seriesIndex].xValues[xIndex], y: seriesArray[seriesIndex].yValues[xIndex] };
		}

		if (seriesArray[seriesIndex].xValues[0] < chart.config.options.scales.xAxes[0].ticks.min) {
			const xMinDate = new Date(seriesArray[seriesIndex].xValues[0]);
			const xMinDateRounded= new Date(xMinDate.getFullYear(), xMinDate.getMonth(), xMinDate.getDate());
			// console.log(`${seriesArray[seriesIndex].xValues[0]} : ${xMinDate} --> ${xMinDateRounded}`);
			chart.config.options.scales.xAxes[0].ticks.min = xMinDateRounded; //seriesArray[seriesIndex].xValues[0];
		}

		if (seriesArray[seriesIndex].xValues[seriesArray[seriesIndex].xValues.length-1] > chart.config.options.scales.xAxes[0].ticks.max) {
			const xMaxDate = new Date(seriesArray[seriesIndex].xValues[seriesArray[seriesIndex].xValues.length-1]);
			const xMaxDateRounded = new Date(xMaxDate.getFullYear(), xMaxDate.getMonth(), xMaxDate.getDate());
			const xMaxDateRounded2 = new Date(xMaxDateRounded.getTime() + DAY_MS);
			// console.log(`${seriesArray[seriesIndex].xValues[seriesArray[seriesIndex].xValues.length-1]} : ${xMaxDate} --> ${xMaxDateRounded} --> ${xMaxDateRounded2}`);
			chart.config.options.scales.xAxes[0].ticks.max = xMaxDate;//seriesArray[seriesIndex].xValues[seriesArray[seriesIndex].xValues.length-1];
		}
	}
	
	chart.config.options.legend.display = seriesArray.length > 1;

	if (seriesArray.length >= 16) {
		chart.config.options.legend.labels.fontSize = 12; // default 18
		chart.config.options.legend.labels.padding = 2; // default 16
		chart.config.options.legend.labels.boxWidth = 16; // default 40
	}
	else if (seriesArray.length >= 12) {
		chart.config.options.legend.labels.fontSize = 14; // default 18
		chart.config.options.legend.labels.padding = 4; // default 16
		chart.config.options.legend.labels.boxWidth = 24; // default 40
	}
	else if (seriesArray.length >= 8) {
		chart.config.options.legend.labels.fontSize = 16; // default 18
		chart.config.options.legend.labels.padding = 8; // default 16
		chart.config.options.legend.labels.boxWidth = 32; // default 40
	}

	if (undefined !== yStepSize) {
		chart.config.options.scales.yAxes[0].ticks.stepSize = yStepSize;	
	}
	chart.config.options.scales.yAxes[0].ticks.min = yMin;
	chart.config.options.scales.yAxes[0].ticks.max = yMax;

	// console.log(`LineChart.js : setupMulti : legend=${chart.config.options.legend.display} y-axis=${chart.config.options.scales.yAxes[0].ticks.min}..${chart.config.options.scales.yAxes[0].ticks.stepSize}..${chart.config.options.scales.yAxes[0].ticks.max}`, chart);
	
	chart.update();
}

// function logSize(id) {
// 	var elem = document.getElementById(id);
// 	if (null !== elem) {
// 		console.log('logSize : ' + elem.id + ' : ' + getWidth(elem) + 'x' + getHeight(elem));
// 	}
// }

// function resizeChart(canvas, width, height) {

// 	canvas = getCanvas(canvas);
	
// 	canvas.style.width = width + 'px';

// 	if (null !== height) {
// 		setHeight(canvas, height);
// 	}
// }

// function getWidth(body) {
// 	var width = 1234;
// 	if (undefined !== body.innerWidth) {
// 		width = body.innerWidth;
// 	}
// 	else if (undefined !== body.clientWidth) {
// 		width = body.clientWidth;
// 	}
// 	return width;
// }

// function getHeight(body) {
// 	var height = 1234;
// 	if (undefined !== body.innerHeight) {
// 		height = body.innerHeight;
// 	}
// 	else if (undefined !== body.clientHeight) {
// 		height = body.clientHeight;
// 	}
// 	return height;
// }

// function getCalculatedStyle(element) {
// 	var retVal = null;
// 	if (element instanceof Element) {
// 		retVal = window.getComputedStyle(element);
// 	}
// 	else {
// 		retVal = element.style;
// 	}
// 	return retVal;
// }

// function getMarginAdjustedWidth(element, parentStyle) {
// 	var width = getWidth(element);
// 	width -= parentStyle.marginLeft.replace('px', '');
// 	width -= parentStyle.marginRight.replace('px', '');
// 	return width;
// }

// function getMarginAdjustedHeight(element, parentStyle) {
// 	var height = getHeight(element);
// 	height -= parentStyle.marginTop.replace('px', '');
// 	height -= parentStyle.marginBottom.replace('px', '');
// 	return height;
// }

// function onResizeWidth(canvas, body) {
// 	canvas = getCanvas(canvas);
// 	var canvasStyle = getCalculatedStyle(canvas);
// 	console.log('onResizeWidth canvas      : ' + canvas.id + ' [' + getWidth(canvas) + ']');
// 	console.log('onResizeWidth body        : ' + body.id + ' [' + getWidth(body) + ']');
// 	console.log('onResizeWidth canvasStyle.margin : ' + canvasStyle.marginLeft + ' - ' + canvasStyle.marginRight );
// 	console.log('onResizeWidth canvasStyle.padding : ' + canvasStyle.padding );
// 	var width = getMarginAdjustedWidth(body, canvasStyle);
// 	console.log('onResizeWidth width       : ' + width);
// 	resizeChart(canvas, width, null);
// }

// function onResizeBody(canvas, body) {
// 	canvas = getCanvas(canvas);
// 	var canvasStyle = getCalculatedStyle(canvas);
// 	var width = getMarginAdjustedWidth(body, canvasStyle);
// 	var height = getMarginAdjustedHeight(body, canvasStyle);
// 	resizeChart(canvas, width, height);
// }

// function setHeight(canvas, height) {

// 	canvas = getCanvas(canvas);
	
// 	const chart = canvas.chart;

// 	if ((undefined !== chart) && (null !== chart)) {
// 		if (canvas.style.height !== (height + 'px')) {
// 			canvas.style.height = height + 'px';
	
// 			for (var seriesIndex = 0; seriesIndex < chart.config.data.datasets.length; seriesIndex++) {
// 				if (undefined === chart.config.data.datasets[seriesIndex].color) {
// 					chart.config.data.datasets[seriesIndex].color = COLORS.PURPLE;
// 				}
// 				else {
// 					console.log(`setHeight : chart.config.data.datasets[${seriesIndex}].color=${chart.config.data.datasets[seriesIndex].color}`);
// 				}
	
// 				updateDatasetColorGradientWithHeight(chart.config.data.datasets[seriesIndex], chart.config.data.datasets[seriesIndex].color, canvas, height);
// 			}
// 		}
// 	}
// 	else {
// 		console.log('[WARNING] setHeight : chart = ' + chart);
// 	}

// }